import "./RenderOptions.css";

const RenderOptions = ({
  designOptions,
  mandatoryValue,
  Component,
  selected,
  handleOptionChange,
  notSelectablePPOCodes,
  dependentConflictRules,
}) => {
  return designOptions
    .filter((singleGroup) => singleGroup?.mandatory === mandatoryValue)
    .map((singleGroup, index) => (
      <Component
        key={`option-comp-${index}`}
        {...{
          index: index,
          singleGroup: singleGroup,
          selected,
          handleOptionChange,
          notSelectablePPOCodes,
          dependentConflictRules,
        }}
      />
    ));
};

export default RenderOptions;
